import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import ButtonNormal from '../../../Buttons/ButtonNormal';

const Container = styled.div`
  border-bottom: 1px solid #e7e7e7;
  padding: 16px;
  
  p {
    color: #484848;
    margin-bottom: 7px;
    font-size: 14px;
  }
  span{
    color: ${props => props.status === 'succeeded' ? "#6ecc47" : "#d74242"};
    font-weight: ${props => props.status === 'unpaid' ? "bold" : "normal"};
    font-style: ${props => props.status === 'unpaid' ? "italic" : "normal"}

  }
`;

const changeWord= (word)=>{
  let text;
  switch(word) {
case 'active':
  text = "activo";
  break;
case 'past_due':
  text = "pasadod";
  break;
case 'unpaid':
  text = "no pagado";
  break;
case 'canceled':
  text = "cancelado";
  break;
case 'incomplete':
  text = "incompleto";
  break;
case 'incomplete_expired':
  text = "incompleto expirado";
  break;
case 'trialing':
  text = "juicio";
  break;
case 'draft':
  text = "espera";
  break;
case 'open':
  text = "abierto";
    break;
case 'succeeded':
  text = "Exitoso";
    break; 
default:
 text = "proceso";
  }
  return text;
}

/* Format amount */
function currencyFormat(num) {
return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const Payment = ({ payment, membershipType }) => {
  return (
    <Container status={payment.status}>
      <p>
        <b>Fecha:</b> {moment.unix(payment.created).utc().format('DD/MM/YYYY')}
      </p>
      <p>
        <b>Pago:</b> <span>{changeWord(payment.status)}</span>
      </p>
      <p>
        <b>Referencia:</b> {payment.number ? payment.number : 'Procesando'}
      </p>
      <p>
        <b>Membresía:</b> {membershipType}
      </p>
      <p>
        <b>Total:</b> {currencyFormat(parseInt(payment.amount.toString().slice(0,-2)))}
      </p>
      {payment.status === 'succeeded' ? (
        <a style={{textDecoration:'none'}} href={payment.receipt_url} target='_blank' rel="noopener noreferrer">
          <ButtonNormal
            variant="secondaryOutlined"
            style={{
              width: 96,
              height: 32,
              maxWidth: 'unset',
              minWidth: 'unset',
            }}
          >
            Recibo
          </ButtonNormal>
        </a>
      ) : (
        <ButtonNormal
          variant="primary"
          style={{
            width: 96,
            height: 32,
            maxWidth: 'unset',
            minWidth: 'unset',
          }}
        >
          Pagar
        </ButtonNormal>
      )}
    </Container>
  );
};

export default Payment;
